module.exports = __webpack_public_path__ + "img/pic_number_10.35c4c2ba.png";